import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { isEmpty } from '@/utils';
export default {
  name: 'lvmama_goods_nav_config',
  components: {
    draggable: draggable
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      menusMap: {},
      dialogVisible: false,
      editConfig: []
    };
  },
  computed: {
    menuListFilter: function menuListFilter() {
      var menus_lvmama = this.menuList.filter(function (i) {
        return i.type === 'lvmama';
      });
      this.menusMap = this.buildChildrenMap(menus_lvmama); // 以id为键 列出childrens枚举
      return menus_lvmama;
    }
  },
  methods: {
    confirmDialogVisible: function confirmDialogVisible() {
      var openData = this.editConfig.find(function (i) {
        return i.flag === true;
      });
      if (openData === undefined) {
        this.$message.error('请至少选择一个分类');
        return;
      }
      this.value.config.value = JSON.parse(JSON.stringify(this.editConfig));
      this.dialogVisible = false;
    },
    handleDialogVisible: function handleDialogVisible() {
      this.editConfig = JSON.parse(JSON.stringify(this.value.config.value));
      this.dialogVisible = true;
    },
    checkNumber: function checkNumber(rule, value, callback) {
      if (value === '') {
        return callback('商品展示行数不可为空');
      } else {
        if (!/^[0-9]*$/.test(value)) {
          callback('仅支持正整数');
        } else if (value > 199 || value < 1) {
          callback('仅支持1-199正整数');
        } else {
          callback();
        }
      }
    },
    changeSwitch: function changeSwitch() {
      this.$refs.form.validate();
    },
    checkList: function checkList(type, value, callback, flag) {
      if (flag && isEmpty(value)) {
        callback("".concat(type === 'sub_name' ? '副标题' : '展示名称', "\u4E0D\u53EF\u4E3A\u7A7A"));
      }
      if (this.value.config.value.some(function (i) {
        return i.flag == true;
      })) {
        callback();
      } else {
        callback('请给要展示的分类选择菜单');
      }
    },
    changeCategory: function changeCategory(val) {
      if (val) {
        var menu = this.menusMap[val] || [];
        var children = menu.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            primitiveName: i.name,
            sub_name: '',
            flag: false
          });
        });
        this.value.config.value = children || [];
      } else {
        this.value.config.value = [];
      }
    },
    buildChildrenMap: function buildChildrenMap(arr) {
      var map = {};
      function recurse(items) {
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            map[item.id] = item.childrens || [];
            if (item.childrens && item.childrens.length > 0) {
              recurse(item.childrens);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      recurse(arr);
      return map;
    }
  },
  created: function created() {
    var _this$value$config$va = this.value.config.value,
      value = _this$value$config$va === void 0 ? [] : _this$value$config$va;
    this.$set(this.value, 'config', _objectSpread({
      category_id: '',
      sort: '3',
      line_number: 5,
      extend_sort: 0,
      list_show_type: 1,
      //列表展示样式 1-固定行数商品 2-上滑无限加载商品
      list_show_more: 1,
      //是否显示加载更多 0-不显示 1-显示,
      show_type: this.value.show_type || 1,
      // 兼容新老组件 默认预置类型为图片是图
      is_open_sub_name: '0',
      //兼容新老组件 默认预置关闭
      is_show_title: 1,
      //兼容新老组件 默认预置显示
      margin_top: 15,
      //兼容新老组件 默认预置15px
      z_index: 2,
      //兼容新老组件 默认预置2
      value: value
    }, this.value.config));
  }
};